import React from 'react'
import styles from './About.module.css'
import { Link } from 'react-router-dom'
import VDbg from '../../asssists/Contact.mp4'
export default function About() {
  return (
    <>
   <section className={styles.about}>
   <video className={styles.aboutBg} src={VDbg} muted loop autoPlay alt="" />
  <div className={styles.aboutContent}>
  <h1 className='text-center text-danger mx-5 px-5 mt-1 pt-5'>Contact US On </h1>
  <div className="container">
  <div className="row">
  <div className="col-md-12">
  <div className={styles.aboutBox}>
  <div  className={styles.aboutIcons}>
  <h5 className='d-flex justify-content-around align-items-center w-100 h-100'>
 <Link to={"https://www.linkedin.com/in/hussein-mohamed-078476290/"} target='_blank' className="nav-link d-flex flex-column justify-content-center align-items-center bg-black p-2 rounded-3">
 <i className="text-white fa-brands fa-linkedin-in"></i>
 <p className='fs-6 text-white mt-2'>Linkedin</p>
 </Link>
 <Link to={"https://www.facebook.com/S7s.fit.37/"} target='_blank' className="nav-link d-flex flex-column justify-content-center align-items-center bg-black p-2 rounded-3">
 <i class="text-white fa-brands fa-facebook-f"></i>
  <p className='fs-6 text-white mt-2'>Facebook</p>
 </Link>
 <Link to={"s7so1234@gmail.com"} target='_blank' className="nav-link d-flex flex-column justify-content-center align-items-center bg-black p-2 rounded-3">
 
 <i class="text-white fa-solid fa-envelope"></i>
 <p className='fs-6 text-white mt-2'>Gmail</p> 
 </Link>
 <Link to={"https://github.com/HusseinMo21?tab=repositories"} target='_blank' className="nav-link d-flex flex-column justify-content-center align-items-center bg-black p-2 rounded-3">
 
<i className=" text-white fa-brands fa-linkedin-in"></i>
 <p className='fs-6 text-white mt-2'>GitHub</p>
 </Link>
 
 <Link to={""} target='_blank' className="nav-link d-flex flex-column justify-content-center align-items-center bg-black p-2 rounded-3">
 <i className="text-white  fa-brands fa-whatsapp"></i>
 
  <p className='fs-6 text-white mt-2'>01093378628</p>
  </Link>


  </h5>
  </div>
  </div>
  
  </div>
  </div>
  </div>
  </div>
   </section>
    </>
  )
}
